import moment from 'moment';
moment.locale('fr');

const cdnUri = process.env.CDN_URI;

export default {
  /**
   * Formatte un email
   * @param text
   */
  email: text => ('' + text).toLowerCase(),

  /**
   * Formatte un numéro de téléphone
   * @param text
   */
  phone: text => {
    const cleanPhone = ('' + text).replace(/[^0-9]+/gim, '');
    if (cleanPhone.match(/^\+\d{11}$/) || cleanPhone.match(/^\d{10}$/)) {
      return cleanPhone.replace(/^(\+\d{3}|\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1 $2 $3 $4 $5');
    }
    return text;
  },

  /**
   * Formate une date
   * @param text
   * @param format
   */
  date: (text, format = 'DD/MM/YYYY') => (text ? moment(text).format(format) : '-'),
  datetime: (text, format = 'DD/MM/YYYY à HH:mm') => (text ? moment(text).format(format) : '-'),
  ago: text => moment(text).from(),

  number: text =>
    Number(text || 0)
      .toFixed(0)
      .replace(/(\d)(\d{3})$/, '$1 $2')
      .replace(/(\d)(\d{3})(\s\d{3})$/, '$1 $2$3'),

  percentage: (percentage, addPlus = true) =>
    `${percentage < 0 || !addPlus ? '' : '+'}${Number((percentage || 0) * 100).toFixed(1)}%`,

  filesize: (sizeInBytes = 0) => {
    const sizes = [[1073741824, 'Go'], [1048576, 'Mo'], [1024, 'ko'], [1, 'octets']];
    let ret = '';
    sizes.forEach(([size, unit]) => {
      if (!ret && sizeInBytes > size / 2) {
        ret = `${Number(sizeInBytes / size)
          .toFixed(2)
          .replace('.', '.')} ${unit}`;
      }
      return !ret;
    });
    return ret || '-';
  },

  capitalize: (text = '') => {
    text = text.trim().toLowerCase();
    let result = '';
    for (let i = 0; i < text.length; i++) {
      if (i === 0 || /^(\s|-)$/.test(text.charAt(i - 1))) {
        result += text.charAt(i).toUpperCase();
      } else {
        result += text.charAt(i);
      }
    }
    return result;
  },

  nl2br: (text = '') => {
    return text.replace(/\r?\n/, '<br />');
  },

  uppercase: text => text.toUpperCase(),

  join: (values = [], sep = ', ') => values.join(sep),

  media: (media, mode = 'original') =>
    `${cdnUri}media/${media.id}/${mode}/${media.hash || '0'}-${media.name}`,
  cdn: (...params) => `${cdnUri}${params.join('/')}`,
};



// WEBPACK FOOTER //
// ./src/filters.js